export const withFilterOnDocumentIdAndSiteId = reducer => (state, action) => {
  if (!state || !action.event) {
    return reducer(state, action);
  }

  const { header } = state;
  if (!header) {
    return reducer(state, action);
  }

  const { eventBody } = action.event;
  const { documentId, siteId } = eventBody;

  if (!Number.isInteger(Number(documentId)) || !Number.isInteger(Number(siteId))) {
    return reducer(state, action);
  }

  if (documentId !== header.documentId || siteId !== header.siteId) {
    return state;
  }

  return reducer(state, action);
};
